import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { CompaniesComponent } from "../../components/companies"
import { DefaultPageComp } from "../../components/defaultPage"
import { CompaniesGroupsComponent } from "../../components/companiesGroups"

export const CompaniesGroupsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <CompaniesGroupsComponent />
    </DefaultPageComp>
  </>
}